
<section class="p-2">

  <lib-dialog-header
    [titulok]="getTitulok()"
    [predmetNazov]="termin ? termin.predmetNazov : ''"
    [predmetSkratka]="termin ? termin.predmetSkratka : ''"
    [doplnujuciText]="termin ? termin.datumSk + ', ' + termin.cas : null">
  </lib-dialog-header>

  <mat-dialog-content class="scrollable-content">
    <mat-spinner *ngIf="loading" class="m-5"></mat-spinner>
    <ul *ngIf="!loading">
      <li *ngIf="terminDetail.fazaPopis">{{terminDetail.fazaPopis}}</li>
      <li *ngFor="let h of terminDetail.hodnotiaci">{{h}}</li>
      <li *ngFor="let m of terminDetail.miestnosti">{{m.kod}}</li>
      <li *ngIf="terminDetail.poznamka">{{terminDetail.poznamka}}</li>
      <li>
        <span class="fw-bold" i18n>Prihlasovanie</span>:
        <div class="ms-3">{{terminDetail.datumPrihlasOd}} <span i18n>do</span> {{terminDetail.datumPrihlasDo}}</div>
      </li>
      <li>
        <span class="fw-bold" i18n>Odhlasovanie</span>:
        <div class="ms-3">{{terminDetail.datumOdhlasOd}} <span i18n>do</span> {{terminDetail.datumOdhlasDo}}</div>
      </li>
      <li *ngIf="terminDetail.maxPocet"><span i18n>Max. počet</span>: {{terminDetail.maxPocet}}</li>
    </ul>

    <div *ngIf="terminDetail && terminDetail.studenti && terminDetail.studenti.length > 0">
      <hr/>
      <h2 i18n>Zoznam prihlásených</h2>
      <div class="m-3">
        <div class="d-flex flex-row">
          <div *ngFor="let s of studenti; last as isLast">
            <span *ngIf="s.plneMeno !== 'unknown'">{{s.plneMeno}}</span><span *ngIf="!isLast">,&nbsp;</span>
          </div>
        </div>
        <div *ngIf="nezverejneniCout > 0">
          <span i18n>nezverejnení</span>: {{nezverejneniCout}}
        </div>
      </div>
    </div>

  </mat-dialog-content>
  <hr/>
  <mat-dialog-actions class="d-flex justify-content-end">
      <button *ngIf="termin.datumPrihlasenia" mat-stroked-button (click)="odhlasit()"><span i18n>Odhlásiť sa</span></button>
      <button *ngIf="!termin.datumPrihlasenia" mat-stroked-button (click)="prihlasit()"><span i18n>Prihlásiť</span></button>
      <button mat-stroked-button mat-dialog-close><span i18n>Close</span></button>
  </mat-dialog-actions>

</section>
